<div class="container">
    <div *ngIf="emailSent">
        <div class="row">
            <div class="col-16">
                <div class="both-at-end">
                    <h1>Electronic Application</h1>
                    <button class="button primary" (click)="viewHistory()">eApplication History</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="text-center">
                    <p>The application was successfully saved and the Electronic Enrollment Application has been sent to the beneficiary at this email address: </p>
                    <strong>{{enrollmentViewModel.APPEMAIL}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="appReject">
        <div class="col-16">
            <p class="text-center">Thank you, your application process has been rejected and notification has been sent to your agent.</p>
        </div>
    </div>
    <div class="row" *ngIf="appCorrection">
        <div class="col-16">
            <p class="text-center">Thank you, your correction request has been submitted and notification has been sent to your agent.</p>
        </div>
    </div>
    <div class="row" *ngIf="urlExpire">
        <div class="col-16">
            <div class="eapp-esoalinkexpired">
                <p><strong>URL/Page has expired.</strong></p>
            </div>
            <p>
                You must continue to pay your Medicare Part B premium.
                {{insurance}} complies with applicable Federal civil rights laws and does not discriminate on the basis of race, color, national origin, age, disability, or sex.
                ATTENTION: If you speak English, language assistance services, free of charge, are available to you. Call 1-866-235-5660 (TTY: 711), 24 hours a day, 7 days a week. ATENCIÓN: Si usted habla español, tenemos servicios de asistencia lingüística disponibles para usted sin costo alguno. Llame al 1-866-235-5660 (TTY: 711), las 24 horas del día, los 7 días de la semana. 小贴士: 如果您说中文，欢迎使用免费语言协助服务。请拨1-866-235-5660 (TTY: 711)。一周7天，每天24小时随时受理。
                {{insurance}} Employer PDP is a Prescription Drug Plan. This plan is offered by {{insurance}}, which has a Medicare contract. Enrollment depends on contract renewal.
                ©2016 {{insurance}}. All Rights Reserved.
                Y0080_12316_WEB_2016 Pending Last Updated: 09/09/2016
            </p>
        </div>
    </div>
    <div class="row" *ngIf="finalSubmit">
        <div class="col-16">
            <p class="text-center">Thank you, your information has been submitted.</p>
        </div>
    </div>
</div>
